<template>
  <div>
    <v-row justify="center">
        <v-col cols="12" sm="12" md="12" lg="12">
            <vuetify-table
                :headers="headers"
                :api-u-r-l="apiURL"
                title="Permisos"
                permisosNuevoRegistro="agregar_permiso"
                permisosEditar="actualizar_permiso"
                permisosEliminar="eliminar_permiso"
            />
        </v-col>
    </v-row>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('permission') };
    },
    components: {
        VuetifyTable,
    },
    data: () => ({
      headers: [{
          text: 'Nombre',
          value: 'name',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Descripción',
          value: 'description',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
      apiURL: 'api/maintenance/permissions',
    }),
    mounted() {
      if (!this.can('actualizar_permiso') && !this.can('eliminar_permiso')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
      }
    },
};
</script>

<style>

</style>
